// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3QfBR","search":"Settings_search__3tcWN","filter":"Settings_filter__369s5"};